import React, { ReactNode, useCallback, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { setSetting, uploadRequest } from "actions";

import { UploadModal } from "components/UploadModal";

import { AttachmentSearchFields } from "constants/attachmentSearch";
import { Settings } from "constants/settings";

import { openAttachments } from "lib/navigation";

import { getSetting } from "selectors";

type ConsignmentId = string | null | undefined;

export interface UseNvdUploadReturn {
  openUpload: (consignmentId: ConsignmentId) => void;
  uploadModal: ReactNode;
}

export const useNvdUpload = (): UseNvdUploadReturn => {
  const [uploadingConsignmentId, setUploadingConsignmentId] =
    useState<ConsignmentId>(undefined);
  const dispatch = useDispatch();
  const agencyId: string | null = useSelector(getSetting(Settings.agencyId));

  const handleUpload = useCallback(
    (file: File) => {
      const formData = {
        consignment: uploadingConsignmentId || undefined,
        agency: agencyId !== null ? agencyId : undefined,
      };

      dispatch(uploadRequest(file, formData));

      if (uploadingConsignmentId) {
        dispatch(
          setSetting(Settings.attachmentSearch, {
            [AttachmentSearchFields.Consignment]: [uploadingConsignmentId],
          }),
        );
      }
      setUploadingConsignmentId(undefined);
      openAttachments();
    },
    [agencyId, dispatch, uploadingConsignmentId],
  );

  const uploadModal = uploadingConsignmentId !== undefined && (
    <UploadModal
      closeSelf={() => setUploadingConsignmentId(undefined)}
      handleUpload={handleUpload}
      key="uploadModal"
    />
  );

  return {
    openUpload: setUploadingConsignmentId,
    uploadModal,
  };
};
